import { createApp } from 'vue'
import App from './App-working.vue'

// Глобальные стили
import './style.css'
// Модульные стили
import './styles/components.css'
import './styles/sessions.css'
import './styles/admin.css'
import './styles/responsive.css'

// Простая локализация без eval (CSP-совместимая)
import i18n from './i18n/index.js'

const app = createApp(App)
app.use(i18n)
app.mount('#app')
